import React, { FC } from 'react';
import { GetAllCustomersFiltered_getAllCustomersFiltered as Customer } from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import CustomerItem from './CustomerItem';
import './Customers.scss';

interface CustomerListProps {
    customers: Customer[];
    refetch?: () => void;
    isLoading: boolean;
    canEditCustomers: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    onEditClick: (Customer: Customer) => void;
    onDelete?: (record: any) => void;
}

const CustomerList: FC<CustomerListProps> = ({
    customers,
    refetch,
    isLoading,
    isEndOfResults,
    onLoadMore,
    onEditClick,
    canEditCustomers,
    onDelete,
}: CustomerListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('customerList', isLoading, isEndOfResults, onLoadMore);

    if (refetch) {
        refetch();
    }

    return (
        <div className="Customers-List" onScroll={handleScroll}>
            {customers.map((customer, index) => (
                <CustomerItem
                    key={customer.id ? customer.id.toString() : '0'}
                    index={index}
                    canEditCustomers={canEditCustomers}
                    customer={customer}
                    onEditClick={onEditClick}
                    onDelete={onDelete}
                ></CustomerItem>
            ))}
        </div>
    );
};

export default CustomerList;

